
$('#carouselHero').slick({
    accessibility: false,
    arrows: true,
    prevArrow: '<button class="slick-prev"><span class="sr-only"></span></button>',
    nextArrow: '<button class="slick-next"><span class="sr-only"></span></button>',
    asNavFor: '.slider-nav',
    fade: true,
    autoplay: true,
    autoplaySpeed: 7000,
    slide: '.carousel-item',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                arrows: false,
            }
        }
    ]
});
$('.slider-nav').slick({
    accessibility: false,
    prevArrow: '<button class="slick-prev"><span class="sr-only"></span></button>',
    nextArrow: '<button class="slick-next"><span class="sr-only"></span></button>',
    asNavFor: '#carouselHero',
    dots: false,
    focusOnSelect: true,
    slidesToScroll: 1,
    slidesToShow: 4,
    infinite: true,
    centerMode: false,
    responsive: [
        {
            breakpoint: 1400,
            settings: {
                asNavFor: '#carouselHero',
                slidesToScroll: 1,
                slidesToShow: 4,

            }
        },
        {
            breakpoint: 1200,
            settings: {
                asNavFor: '#carouselHero',
                slidesToScroll: 1,
                slidesToShow: 2,

            }
        },
        {
            breakpoint: 768,
            settings: {
                asNavFor: '#carouselHero',
                slidesToScroll: 1,
                slidesToShow: 1,
            }
        }
    ]
});